import {
	InnerBlocks,
	useBlockProps,
	__experimentalGetColorClassesAndStyles as getColorClassesAndStyles,
	__experimentalGetSpacingClassesAndStyles as getSpacingClassesAndStyles,
} from "@wordpress/block-editor";

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save(props) {
	const { attributes } = props;
	const colorProps = getColorClassesAndStyles(attributes);
	const spacingProps = getSpacingClassesAndStyles(attributes);
	const customStyle = {
		"--wpopus-blob-size": `${attributes.blobSize}px`,
		"--wpopus-blob-pause-on-hover": `${
			attributes.blobStopOnHover ? "paused" : "running"
		}`,
	};

	const blobStyle = {
		...colorProps.style, // Default color styles
		...spacingProps.style, // Default spacing styles
		...customStyle,
	};

	return (
		<div
			{...useBlockProps.save({ className: `wpopus-blob ${attributes.blobStyle}` })}
			style={blobStyle}
		>
			<InnerBlocks.Content />
		</div>
	);
}
